module.exports = __webpack_public_path__ + "static/media/picture7.ace00612.jpg";